import { RootState } from "src/redux/store";

export const userLoadingSelector = (state: RootState) => state.userStore.isLoading;

export const tokenSelector = (state: RootState) => state.userStore.jwt;

export const currentUserSelector = (state: RootState) => state.userStore.loggedInUser;
